import { frontendURL } from 'dashboard/helper/URLHelper';
import AgendaView from './AgendaView.vue';
import { ROLES, CONVERSATION_PERMISSIONS } from 'dashboard/constants/permissions.js';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/agenda'),
    name: 'agenda_index',
    component: AgendaView,
    meta: {
      permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
    },
  },
];
